import { useTranslation } from "react-i18next";
import { CRadio } from ".";
import { CRadioGroupProps } from "./radio-group";
import React from "react";

export const CRadioAccept: React.FC<CRadioGroupProps> = ({ ...props }) => {
  const { t } = useTranslation();
  const options = [
    { label: t("accept"), value: true },
    { label: t("no-accept"), value: false },
  ];
  return <CRadio.Group {...props} options={options} />;
};
